import * as React from 'react';
import { MetricCounter } from './MetricCounter';
import { useContext } from 'react';
import { AnalyticsContext } from '../../AnalyticsProvider';
import { AudienceGrowthChart } from './AudienceGrowthChart';
import { ProfileFollowersStats } from '../../../../models/graphql';
import classNames from 'classnames';
import classes from './Overview.module.scss';

export type OverviewViewProps = {
  totalFollowers: number | null;
  totalEngagement: number | null | undefined;
  totalPosts: number | null | undefined;
  impressions: number | null | undefined;
  followersByProfile: ProfileFollowersStats[];
  loading: boolean;
};
export const OverviewView = ({
  totalFollowers,
  followersByProfile,
  totalEngagement,
  impressions,
  totalPosts,
  loading
}: OverviewViewProps) => {
  const { startDate, endDate } = useContext(AnalyticsContext);
  return (
    <>
      <div className={classNames('margin-bottom-small-16', classes.MetricsContainer)}>
        <MetricCounter
          title={'Followers'}
          metricValue={totalFollowers}
          dateEnd={endDate}
          tooltipText={'Total number of followers'}
          loading={loading}
        />
        <MetricCounter
          title={'Engagement'}
          metricValue={totalEngagement}
          dateStart={startDate}
          dateEnd={endDate}
          tooltipText={'Total likes, comments and shares combined'}
          loading={loading}
        />
        <MetricCounter
          title={'Impressions'}
          metricValue={impressions}
          dateStart={startDate}
          dateEnd={endDate}
          tooltipText={'Total number of times these Posts have been viewed'}
          loading={loading}
        />
        <MetricCounter
          title={'Total Number of Posts'}
          metricValue={totalPosts}
          dateStart={startDate}
          dateEnd={endDate}
          tooltipText={'How many Posts were published during this date range'}
          loading={loading}
        />
      </div>
      <div className={'cell medium-12'}>
        <AudienceGrowthChart followersByProfile={followersByProfile} loading={loading} />
      </div>
    </>
  );
};
